import { render, staticRenderFns } from "./stockDetailStatusTracker.vue?vue&type=template&id=1184e580&scoped=true"
import script from "./stockDetailStatusTracker.vue?vue&type=script&lang=js"
export * from "./stockDetailStatusTracker.vue?vue&type=script&lang=js"
import style0 from "./stockDetailStatusTracker.vue?vue&type=style&index=0&id=1184e580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1184e580",
  null
  
)

export default component.exports